module.exports = __webpack_public_path__ + "static/img/icon-upload-loading.6f839716.svg";